module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEeSURBVGhD7daxSgNBEMbxA0ErC8EmzyBWdsEgu2m096JpfBGfIinMbLS18AqjSXwKk10VQcgTJLZWIYKOMhcMWClcbo7vB0NgiuP+ZHOXCAAAAAAgd/bcYNOQH1vyV3HyvCprfXbPnjaM8xPrwgcHdVTHmHbYshRev2J4bhCTFwsxFG7Vx8x/M853EZMXCzHke4WJ4fdMHzG/qdB9yZwPdzKdlj/h4zX9jnHh7t8x5YuXdev8m1xwacNR13JLfxMnyQo/3y95BllP+o0YCu/WDY/llnThgNM0go9ZXda6FC6iEMepSg9HstalcBH8MqzJWpefEfwZy1qXNIJnhohlqtLj9jyi5Q9lrc9+Y7TGEU3+D3cgKwAAAACALETRJ8SqxAfP7/TlAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic-route-arrow-light.png
// module id = 262
// module chunks = 0